import { useTranslation } from "react-i18next";
import image_01 from '../../img/About/Banner/image_01.jpg';
import image_02 from '../../img/About/Banner/image_02.jpg';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="relative mt-[60px] xl:mt-[100px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex md:flex-row flex-col-reverse">
                    <div className="xl:pt-[60px] pt-[25px] xl:pr-[50px] md:pr-[25px] pb-[13px] md:w-[50%]">
                        <h1 className="open-sans text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('about.banner.title')}
                        </h1>
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780] lg:mt-[30px] mt-[15px]">
                            {t('about.banner.text_01')}
                        </p>
                    </div>
                    <div className="md:w-[50%] sm:w-[100%] w-[calc(100%+40px)] sm:ml-0 ml-[-20px]">
                        <img className="w-[100%]" src={image_01} alt='' />
                    </div>
                </div>
                <div className="flex md:flex-row flex-col-reverse">
                    <div className="md:w-[50%] hidden md:block">
                        <img className="w-[100%]" src={image_02} alt='' />
                    </div>
                    <div className="xl:pt-[60px] md:pt-[25px] pt-[0] xl:pl-[50px] md:pl-[25px] md:w-[50%]">
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                            {t('about.banner.text_02')}
                        </p>
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('about.banner.text_03')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
